var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-menu-grouping-mobile"},[_c('menu-item',{ref:"mobileGrouping",attrs:{"title":_vm.activeItem.title,"icon":_vm.activeItem.icon,"decorative-dropdown":false},on:{"click":_vm.handleOpenMobileMenu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }